interface ConfidenceProps {
  percentage: number;
}

export const Confidence = ({ percentage }: ConfidenceProps) => {
  const getColor = () => {
    if (percentage >= 90) return "bg-emerald-500";
    if (percentage >= 70) return "bg-yellow-500";
    if (percentage >= 50) return "bg-red-500";
    return "bg-red-500";
  };

  return (
    <div className="flex w-full items-center gap-2">
      <div className="h-2 w-[32px] overflow-hidden rounded-full bg-gray-200">
        <div className={`h-full ${getColor()} transition-all duration-300`} style={{ width: `${percentage}%` }}></div>
      </div>
      <span className="text-sm font-medium text-gray-700">{percentage}%</span>
    </div>
  );
};
